import { createHistoryRouter, createRoute, redirect } from 'atomic-router'
import { sample } from 'effector'
import {
  AppStarted,
  goOnPrivateError,
  goToAuth,
  goToCaseList,
  goToMain,
  goToNewAuth,
  goToOnboarding,
  goToProfile,
  goToReward,
  goToUpdate,
  goToTon,
  onError,
  goToTest,
  goToLastProgress,
  goToDevTools,
  goToDoubleConnection,
  goToConnectSteam,
  goToNews,
  goToTransactionStatus,
  goToTransactionHistory,
  goToTopUpSteam,
  goToCase,
  goToDailyBonus,
  goToLeaderboard,
  goToSocial,
  goToTasks,
  goToConnectPlatform,
  goToFarcanaProfile,
  goToUnifiedProfile,
  goToRecommendations,
  goToExternalUnifiedProfile,
  goToEpicProfile,
  goToShop,
  goToUpdating,
  goToStarterPack,
  goToStarterPackClaim,
} from './events'

import { createBrowserHistory } from 'history'

const routes = {
  recommendations: createRoute(),
  devTools: createRoute(),
  news: createRoute(),
  lastProgress: createRoute(),
  newYear: createRoute(),
  start: createRoute(),
  onboarding: createRoute(),
  main: createRoute(),
  profile: createRoute(),
  auth: createRoute(),
  newAuth: createRoute(),
  update: createRoute(),
  test: createRoute(),
  privateError: createRoute(),
  otherError: createRoute(),
  caseList: createRoute(),
  tonConnect: createRoute(),
  reward: createRoute(),
  opening: createRoute(),
  doubleConnection: createRoute(),
  connectSteam: createRoute(),
  transactionStatus: createRoute(),
  transactionHistory: createRoute(),
  topUpSteam: createRoute(),
  case: createRoute(),
  dailyBonus: createRoute(),
  leaderboard: createRoute(),
  social: createRoute(),
  tasks: createRoute(),
  connectPlatform: createRoute(),
  farcanaProfile: createRoute(),
  epicProfile: createRoute(),
  unifiedProfile: createRoute(),
  externalUnifiedProfile: createRoute(),
  shop: createRoute(),
  updating: createRoute(),
  starterPack: createRoute(),
  starterPackClaim: createRoute(),
}

export const mappedRoutes = [
  {
    route: routes.recommendations,
    path: '/recommendations',
  },
  {
    route: routes.devTools,
    path: '/devtools',
  },
  {
    route: routes.farcanaProfile,
    path: '/farcana',
  },
  {
    route: routes.epicProfile,
    path: '/epic',
  },
  {
    route: routes.news,
    path: '/news',
  },
  {
    route: routes.lastProgress,
    path: '/lastprogress',
  },
  {
    route: routes.newYear,
    path: '/newyear',
  },
  {
    route: routes.test,
    path: '/test',
  },
  {
    route: routes.start,
    path: '/',
  },
  {
    route: routes.auth,
    path: '/auth',
  },
  {
    route: routes.onboarding,
    path: '/onboarding',
  },
  {
    route: routes.main,
    path: '/main',
  },
  {
    route: routes.profile,
    path: '/profile',
  },
  {
    route: routes.update,
    path: '/update',
  },
  {
    route: routes.privateError,
    path: '/private-error',
  },
  {
    route: routes.unifiedProfile,
    path: '/unified-profile',
  },
  {
    route: routes.otherError,
    path: '/other-error',
  },
  {
    route: routes.newAuth,
    path: '/auth/new-auth',
  },
  {
    route: routes.caseList,
    path: '/case-list',
  },
  {
    route: routes.tonConnect,
    path: '/ton-connect',
  },
  {
    route: routes.reward,
    path: '/reward',
  },
  {
    route: routes.opening,
    path: '/opening',
  },
  {
    route: routes.doubleConnection,
    path: '/double-connection',
  },
  {
    route: routes.connectSteam,
    path: '/connect-steam',
  },
  {
    route: routes.transactionStatus,
    path: '/transaction-status',
  },
  {
    route: routes.transactionHistory,
    path: '/transacton-history',
  },
  {
    route: routes.topUpSteam,
    path: '/top-up-steam',
  },
  {
    route: routes.case,
    path: '/case',
  },
  {
    route: routes.dailyBonus,
    path: '/daily-bonus',
  },
  {
    route: routes.leaderboard,
    path: '/leaderboard',
  },
  {
    route: routes.social,
    path: '/social',
  },
  {
    route: routes.tasks,
    path: '/tasks',
  },
  {
    route: routes.connectPlatform,
    path: '/connect-platform',
  },
  {
    route: routes.externalUnifiedProfile,
    path: '/external-unified-profile',
  },
  {
    route: routes.shop,
    path: '/shop',
  },
  {
    route: routes.updating,
    path: '/updating',
  },
  {
    route: routes.starterPack,
    path: '/starter-pack',
  },
  {
    route: routes.starterPackClaim,
    path: '/starter-pack-claim',
  },
]

const router: ReturnType<typeof createHistoryRouter> = createHistoryRouter({
  routes: mappedRoutes,
})

sample({
  clock: AppStarted,
  fn: () => createBrowserHistory(),
  target: router.setHistory,
})

redirect({
  clock: goToRecommendations,
  route: routes.recommendations,
})

redirect({
  clock: goToEpicProfile,
  route: routes.epicProfile,
})

redirect({
  clock: goToLastProgress,
  route: routes.lastProgress,
})

redirect({
  clock: goToUnifiedProfile,
  route: routes.unifiedProfile,
})
redirect({
  clock: goToNews,
  route: routes.news,
  query: (params) => ({ variant: params.variant }),
})
redirect({
  clock: goToDevTools,
  route: routes.devTools,
})
redirect({
  clock: goToOnboarding,
  route: routes.onboarding,
})

redirect({
  clock: goToTest,
  route: routes.test,
})

redirect({
  clock: goToMain,
  route: routes.main,
})

redirect({
  clock: goToProfile,
  route: routes.profile,
})

redirect({
  clock: goToUpdate,
  route: routes.update,
})
redirect({
  clock: goOnPrivateError,
  route: routes.privateError,
})
redirect({
  clock: goToAuth,
  route: routes.auth,
})
// redirect({
//   clock: goToConnection,
//   route: routes.connection,
// })
redirect({
  clock: onError,
  route: routes.otherError,
})
redirect({
  clock: goToNewAuth,
  route: routes.newAuth,
})
redirect({
  clock: goToCaseList,
  route: routes.caseList,
})
redirect({
  clock: goToTon,
  route: routes.tonConnect,
})
redirect({
  clock: goToReward,
  route: routes.reward,
})
redirect({
  clock: goToDoubleConnection,
  route: routes.doubleConnection,
  query: (params) => ({ platform: params.platform }),
})
redirect({
  clock: goToConnectSteam,
  route: routes.connectSteam,
})
redirect({
  clock: goToTransactionStatus,
  route: routes.transactionStatus,
  query: (params) => ({ hash: params.hash }),
})
redirect({
  clock: goToTransactionHistory,
  route: routes.transactionHistory,
})
redirect({
  clock: goToTopUpSteam,
  route: routes.topUpSteam,
})
redirect({
  clock: goToCase,
  route: routes.case,
  query: (params) => ({ id: params.id }),
})
redirect({
  clock: goToDailyBonus,
  route: routes.dailyBonus,
  query: (params) => ({ variant: params.variant || 'default' }),
})
redirect({
  clock: goToLeaderboard,
  route: routes.leaderboard,
})
redirect({
  clock: goToSocial,
  route: routes.social,
  query: (params = { tab: 0 }) => ({ tab: params?.tab }),
})
redirect({
  clock: goToTasks,
  route: routes.tasks,
  query: (params = { tab: 0 }) => ({ tab: String(params?.tab) }),
})
redirect({
  clock: goToConnectPlatform,
  route: routes.connectPlatform,
  query: (params) => ({ platform: params.platform }),
})
redirect({
  clock: goToFarcanaProfile,
  route: routes.farcanaProfile,
})
redirect({
  clock: goToExternalUnifiedProfile,
  route: routes.externalUnifiedProfile,
  query: (params) => ({ tid: params.tid, gamed_id: params.gamed_id, fromSocialTab: params?.fromSocialTab }),
})
redirect({
  clock: goToShop,
  route: routes.shop,
  query: (params = { tab: 0 }) => ({ tab: params?.tab }),
})
redirect({
  clock: goToUpdating,
  route: routes.updating,
})
redirect({
  clock: goToStarterPack,
  route: routes.starterPack,
})
redirect({
  clock: goToStarterPackClaim,
  route: routes.starterPackClaim,
})

export { routes, router }
